import React from 'react';
import ResultList from '../components/ResultList';

const MbtiTest = () => {
    return (
        <div className="mbti-wrapper">
            <h1 className="hidden-obj">MBTI</h1>
            <ResultList />
        </div >
    )
}

export default MbtiTest;